import { userApi } from "../../api/userApi";
import User from "../../models/user";
import { actionsDefinition } from '../actionsDefinition';
import { httpCallStartAction } from "../../middlewares/http/actions";

export const loadUsersAction = () => (dispatch: any) => {
    dispatch(httpCallStartAction());
    userApi.GetUsersAsync().then((result) => {
        dispatch(loadUserCompleted(result));
    })

    const loadUserCompleted = (result: User[]) => ({
        type: actionsDefinition.LOAD_USERS,
        payload: result,
        meta: {
            httpEnd: true
        }
    });
}